import { Fragment } from "react";

/** Render inline `**bold**` spans inside a single line of text. */
function renderInline(text: string) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((segment, index) => {
    const bold = /^\*\*([^*]+)\*\*$/.exec(segment);

    return bold ? (
      <strong key={index}>{bold[1]}</strong>
    ) : (
      <Fragment key={index}>{segment}</Fragment>
    );
  });
}

export function TextPart({ text }: { text: string }) {
  const lines = text.split("\n");
  const blocks: React.ReactNode[] = [];
  let bullets: string[] = [];

  const flushBullets = (key: string) => {
    if (bullets.length === 0) return;
    const items = bullets;

    bullets = [];
    blocks.push(
      <ul className="my-xs list-disc pl-lg" key={key}>
        {items.map((item, index) => (
          <li key={index}>{renderInline(item)}</li>
        ))}
      </ul>,
    );
  };

  for (const [index, line] of lines.entries()) {
    const heading = /^\s*(#{1,6})\s+(.*)$/.exec(line);

    if (heading) {
      flushBullets(`ul-${index}`);
      const isLarge = (heading[1]?.length ?? 0) <= 2;

      blocks.push(
        <p
          className={`mb-xxs mt-sm font-semibold ${isLarge ? "text-md" : "text-sm"}`}
          key={`h-${index}`}
        >
          {renderInline(heading[2] ?? "")}
        </p>,
      );
      continue;
    }

    const bullet = /^\s*[*-]\s+(.*)$/.exec(line);

    if (bullet) {
      bullets.push(bullet[1] ?? "");
      continue;
    }

    flushBullets(`ul-${index}`);

    if (line.trim() === "") {
      blocks.push(<div className="h-sm" key={`sp-${index}`} />);
    } else {
      blocks.push(<p key={`p-${index}`}>{renderInline(line)}</p>);
    }
  }

  flushBullets("ul-end");

  return <div className="text-sm leading-relaxed">{blocks}</div>;
}
